import {baseInstance} from './baseInstance';

export const ressourcesApi = {
        getAll: () => baseInstance.get(`/ressources`),
        update: (id, data) => baseInstance.put(`/ressources/${id}`, data),
        openReport: (id) => baseInstance.post(`/ressources/${id}/reports/preview`),
        addComment: (id, data) => baseInstance.post(`/ressources/${id}/comments`, data),
        addContactAttempt: (id, data) => baseInstance.post(`/ressources/${id}/contactattempts`, data),
        updateStatus: (id, data) => baseInstance.put(`/ressources/${id}/status`, data),
}